import { render, staticRenderFns } from "./complaintDetails.vue?vue&type=template&id=7b661908&scoped=true&"
import script from "./complaintDetails.vue?vue&type=script&lang=js&"
export * from "./complaintDetails.vue?vue&type=script&lang=js&"
import style0 from "./complaintDetails.vue?vue&type=style&index=0&id=7b661908&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b661908",
  null
  
)

export default component.exports